<template>
    <section class="showcase-section">
      <div class="container">
        <!-- En-tête de section -->
        <div class="row">
          <div class="col-12 text-center">
            <div class="section-header">
              <h2 class="section-title">{{ t('showcase.title') }}</h2>
              <p class="section-subtitle">{{ t('showcase.subtitle') }}</p>
            </div>
          </div>
        </div>
  
        <!-- Profils en ligne horizontale -->
        <div class="row">
          <div class="col-12">
            <!-- Indication de défilement sur mobile -->
            <div class="scroll-hint d-block d-md-none text-center mb-3">
                <small class="text-muted">
              <i class="fas fa-hand-point-right me-1"></i>
              {{ t('showcase.scrollHint') }}
            </small>
            </div>
            
            <div class="profiles-horizontal">
              <!-- Skeleton loader pendant le chargement -->
              <div v-if="isLoading" class="profile-item" v-for="i in 5" :key="i">
                <div class="profile-circle skeleton-loader">
                  <div class="skeleton-avatar"></div>
                </div>
                <div class="profile-text">
                  <div class="skeleton-name"></div>
                  <div class="skeleton-title"></div>
                  <div class="skeleton-link"></div>
                </div>
              </div>
              
              <!-- Profils réels une fois chargés -->
              <div 
                v-else
                v-for="(profile, index) in showcaseProfiles" 
                :key="profile.username || index"
                class="profile-item"
                @click="openProfile(profile.url)"
              >
                <div class="profile-circle">
                  <img :src="profile.avatar" :alt="profile.name" />
                </div>
                <div class="profile-text">
                  <h4 class="profile-name">
                    <i class="fas fa-check-circle verified-icon" v-if="profile.verified"></i>
                    {{ profile.name }}
                  </h4>
                  <p class="profile-title">{{ profile.title }}</p>
                  <p class="profile-link">{{ profile.link }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Call to action -->
        <div class="row">
          <div class="col-12 text-center">
            <div class="showcase-cta">
              <h3>{{ t('showcase.cta.title') }}</h3>
              <p>{{ t('showcase.cta.description') }}</p>
              <router-link to="/inscription" class="btn btn-primary btn-lg">
                {{ t('showcase.cta.button') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { useTranslation } from '@/composables/useTranslation'
  import { ref, onMounted } from 'vue'
  import { dashboardService } from '@/services/api'
  
  export default {
    name: 'ShowcaseSection',
    setup() {
      const { t } = useTranslation()
      
      // États pour les données réelles des utilisateurs
      const showcaseProfiles = ref([])
      const isLoading = ref(true)
      const BASE_URL = '' // Comme dans neolink.vue
      
      // Usernames des profils à afficher
      const showcaseUsernames = ['dara', 'nasro',  'sheratondj',  'guccikrric','tare']

      // Fonction pour charger les données réelles des utilisateurs
      const loadShowcaseProfiles = async () => {
        try {
          isLoading.value = true
          const profiles = []
          
          // Charger chaque profil en parallèle
          const profilePromises = showcaseUsernames.map(async (username) => {
            try {
              const response = await dashboardService.getUserProfile(username)
              
              if (response.data.success && response.data.data && response.data.data.statut === 1) {
                const userData = response.data.data
                
                // Déterminer le titre basé sur le username ou d'autres critères
                let title = 'Utilisateur'
                switch (username) {
                  
                  case 'guccikrric':
                    title = ' Social media influencer'
                    break
                  case 'tare':
                    title = 'Computer Engineer'
                    break
                  case 'sheratondj':
                    title = 'Entreprise'
                    break
   
case 'dara':
  title = 'Marketing Strategist'
  break

  
case 'nasro':
  title = 'Social Activiste'
  break
                }

                
                return {
                  name: userData.name,
                  title: title,
                  avatar: userData.avatar_path ? `${BASE_URL}${userData.avatar_path}` : 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
                  link: `neolinks.me/${username}`,
                  url: `https://neolinks.me/${username}`,
                  verified: true,
                  username: username
                }
              }
              return null
            } catch (error) {
              console.error(`Erreur lors du chargement du profil ${username}:`, error)
              return null
            }
          })
          
          const results = await Promise.all(profilePromises)
          
          // Filtrer les profils valides et les ajouter
          showcaseProfiles.value = results.filter(profile => profile !== null)
          
          // Si aucun profil n'a été chargé, utiliser les données par défaut
          if (showcaseProfiles.value.length === 0) {
            showcaseProfiles.value = getDefaultProfiles()
          }
          
        } catch (error) {
          console.error('Erreur lors du chargement des profils showcase:', error)
          // En cas d'erreur, utiliser les données par défaut
          showcaseProfiles.value = getDefaultProfiles()
        } finally {
          isLoading.value = false
        }
      }
      
      // Données par défaut en cas d'échec de chargement
      const getDefaultProfiles = () => {
        return [
          {
            name: "Dr. Kadir",
            title: "Entrepreneur",
            avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
            link: "neolinks.me/kadir",
            url: "https://neolinks.me/kadir",
            verified: true
          },
          {
            name: "Elie Croupy",
            title: "Content Creator",
            avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            link: "neolinks.me/eliecroupy",
            url: "https://neolinks.me/eliecroupy",
            verified: true
          },
          {
            name: "Tare",
            title: "Content Creator",
            avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
            link: "neolinks.me/tare",
            url: "https://neolinks.me/tare",
            verified: true
          },
          {
            name: "Sheraton Djibouti",
            title: "Entreprise",
            avatar: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=150&h=150&fit=crop&crop=center",
            link: "neolinks.me/sheratondj",
            url: "https://neolinks.me/sheratondj",
            verified: true
          },
          {
            name: "Bapayves",
            title: "Business Coach",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
            link: "neolinks.me/bapayves",
            url: "https://neolinks.me/bapayves",
            verified: true
          }
        ]
      }
      
      const openProfile = (url) => {
        window.open(url, '_blank')
      }
      
      // Charger les profils au montage du composant
      onMounted(() => {
        loadShowcaseProfiles()
      })
      
      return { 
        t,
        showcaseProfiles,
        isLoading,
        openProfile
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  // Variables
  $primary-color: #000000;
  $secondary-color: #ffffff;
  $text-dark: #1a1a1a;
  $text-gray: #666;
  $text-light: #999;
  $border-light: #e5e5e5;
  $blue-verified: #1DA1F2;
  
  // Mixins
  @mixin responsive($breakpoint) {
    @media (max-width: $breakpoint) {
      @content;
    }
  }
  
  .showcase-section {
    padding: 5rem 0;
    background: $secondary-color;
    
    @include responsive(992px) {
      padding: 3rem 0;
    }
  }
  
  .section-header {
    margin-bottom: 4rem;
    
    @include responsive(992px) {
      margin-bottom: 3rem;
    }
  }
  
  .section-title {
    font-size: clamp(2rem, 4vw, 2.5rem);
    font-weight: 800;
    color: $text-dark;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
  
  .section-subtitle {
    font-size: clamp(1rem, 2vw, 1.1rem);
    color: $text-gray;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
  
  .profiles-horizontal {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3rem;
    margin-bottom: 4rem;
    flex-wrap: wrap;
    
    @include responsive(768px) {
      justify-content: flex-start;
      overflow-x: auto;
      overflow-y: hidden;
      flex-wrap: nowrap;
      gap: 2rem;
      padding: 1rem 0;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      
      // Style de la scrollbar
      &::-webkit-scrollbar {
        height: 6px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        
        &:hover {
          background: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  
  .profile-item {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 120px;
    flex-shrink: 0; // Empêche la compression sur mobile
    
    &:hover {
      transform: translateY(-5px);
      
      .profile-circle {
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        
        img {
          transform: scale(1.05);
        }
      }
    }
    
    @include responsive(768px) {
      min-width: 100px;
    }
  }
  
  .profile-circle {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto 1rem;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    
    @include responsive(576px) {
      width: 80px;
      height: 80px;
    }
  }
  
  .verified-badge {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 24px;
    height: 24px;
    background: $blue-verified;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid $secondary-color;
    
    i {
      color: white;
      font-size: 10px;
      font-weight: bold;
    }
    
    @include responsive(576px) {
      width: 20px;
      height: 20px;
      bottom: 3px;
      right: 3px;
      border-width: 2px;
      
      i {
        font-size: 8px;
      }
    }
  }
  
  .profile-text {
    margin-top: 1rem;
  }
  
  .verified-icon {
    color: $blue-verified;
    font-size: 0.9rem;
    margin-right: 0.3rem;
    vertical-align: middle;
  }
  
  .profile-name {
    font-size: 1rem;
    font-weight: 600;
    color: $text-dark;
    margin-bottom: 0.15rem;
    line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @include responsive(576px) {
      font-size: 0.9rem;
    }
  }
  
  .profile-title {
    font-size: 0.8rem;
    color: $text-gray;
    margin-bottom: 0.15rem;
    font-weight: 500;
    
    @include responsive(576px) {
      font-size: 0.75rem;
    }
  }
  
  .profile-link {
    font-size: 0.75rem;
    color: $text-light;
    margin: 0;
    line-height: 1.2;
    
    @include responsive(576px) {
      font-size: 0.7rem;
    }
  }
  
 

  .showcase-cta {
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.08) 0%, rgba(52, 168, 83, 0.08) 100%);
  padding: 2.5rem 2rem;
  border-radius: 20px;
  border: 1px solid rgba(66, 133, 244, 0.15);
  box-shadow: 0 4px 20px rgba(66, 133, 244, 0.1);
  
  h3 {
    font-size: clamp(1.4rem, 2.5vw, 1.8rem);
    font-weight: 700;
    color: $text-dark;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 0.95rem;
    color: $text-gray;
    margin-bottom: 1.8rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.6;
    text-align: center;
  }
  
  .btn {
    padding: 0.8rem 2rem;
    font-size: 0.9rem;
    border-radius: 8px !important;
    font-weight: 600;
    text-decoration: none !important;
    transition: all 0.3s ease;
    
    &.btn-primary {
      background-color: #000000 !important;
      border: 2px solid #000000 !important;
      color: white !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      
      &:hover {
        background-color: #333333 !important;
        border-color: #333333 !important;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
      }
    }
  }
  
  @include responsive(768px) {
    padding: 1.8rem 1.2rem;
    
    p {
      font-size: 0.9rem;
    }
    
    .btn {
      padding: 0.7rem 1.5rem;
      font-size: 0.85rem;
    }
  }
}
  </style>